import React from 'react';
import { MessageCard, i18n, tokens } from '@simplybenefits/sb-ui-library';

/**
 * 
 * @returns 
 */
const NoBankingInfoSetUp = ({ isDependent, addBanking }) => {
    if (isDependent) {
        return (
            <MessageCard
                title={ i18n.t(tokens.titles.noBankingData)}
                subtitle={ i18n.t(tokens.labels.dashboard.mainAccountHolderNoPaymentSetup)}
                small
            />
        );
    }

    return (
        <MessageCard
            title={ i18n.t(tokens.titles.noBankingData)}
            subtitle={ i18n.t(tokens.labels.dashboard.youNoPaymentSetup)}
            btnName={ i18n.t(tokens.buttons["add banking"])}
            btn
            btnOnClick={ addBanking }
            small
        />
    );
};

export default NoBankingInfoSetUp;